import { EditProfileScreen } from '@/screens/profile/edit-profile-screen';
export default EditProfileScreen;
